/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-case-declarations */
import PropTypes from 'prop-types';
import * as React from 'react';

// export file - kb
import {newApi} from '../api/hdcapi';
import {storeReducer} from '../components/Reducers/index';

export const Context = React.createContext();

//Actions and Action Creators
const StoreProvider = ({children}) => {
  //const history = useHistory();
  const [state, dispatch] = React.useReducer(storeReducer, {key_data: false, cds: false, metaDataAboutUser:{
    orgName: '', orgId: -1, org_role: '', legalNotice: false}, orgData: [], reminderData: [],
  uniqOID:[], json:[], questionJson: [], sectionJson:[], errorMessage: null, mappedTableFields:[], bfcp_he_lock_description: '', selSearchVal:'', dynamicDisplayMajors: [], selecallcolumns: [null, null, null, null, null, null, null, null, null], searchTerm: '', featureFlagStatus: {} });

  //--get organization
  const getOrganizations = React.useCallback(async () => {
    try {
      const result = await newApi.get('/organizations', {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(result.status!==200) {
        return window.location.replace('apierror');
      }
      return dispatch({type: 'GET_ORGANIZATIONS', payload: result.data});
    } catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  }, []);

  //PUT api to update legal notice
  const updateLegalNotice = async (id, submitdata) => {
    try {
      await newApi.put(`/organizations/${id}`, submitdata, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
    } catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  };
  //---- /GET categories/{id} API
  const getCategory = async org_id => {
    try {
      const result = await newApi.get(`/organizations/${org_id}/categories`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;
    } catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  };

  const publishCategory = async (data, org_id) => {
    try {
      const result = await newApi.put(`/organizations/${org_id}/categories`, data, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      return result;
    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not publish data'});
    }
  };
  /**
   *  - get cat id
   * @param {string} cat_id
   * @param {string} org_id
   */
  const getModules = async(org_id, cat_id) => {
    try {
      const result = await newApi.get(`/organizations/${org_id}/categories/${cat_id}/questions`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }

      return result.data;
    } catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  };

  const getModuleById = async (org_id, cat_id, m_id) => {
    try {
      const res = await newApi.get(`/organizations/${org_id}/categories/${cat_id}/modules/${m_id}`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(res.status!==200||res.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return res.data;
    }catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  };

  const getMajorsByKeyword = async (org_id, keyword) => {
    try {
      const res = await newApi.get(`/organizations/${org_id}/degreeOfferings?majorName=${keyword}`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(res.status!==200||res.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return res.data;
    }catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  };

  //post error handled by modal
  const postModule = async (data, org_id) => {
    try {
      const result = await newApi.put(`/organizations/${org_id}/questions`, data, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      return result;
    } catch (error) {

      dispatch({type:'ERROR', payload: 'error'});
    }
  };

    //post error handled by modal
    const postAPCPModule = async (data, org_id) => {
      try {
        const result = await newApi.put(`/organizations/${org_id}/apCreditPolicies`, data, {
          headers: {
            'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
            'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
          }
        });
        return result;
      } catch (error) {
  
        dispatch({type:'ERROR', payload: 'error'});
      }
    };

  /**
   * This is used to submit the module
   * error handled by modal
   */
  const submitModule = async(data, org_id) => {
    try {
      const result = await newApi.put(`/organizations/${org_id}/categories`, data, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      return result;
    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not submit data'});
    }
  };

  /**
   * This is used to unsubmit the module
   * error handled by modal
   * No payload needed
   * https://hdc-api-<env>.collegeplanning-nonprod.collegeboard.org/organizations/<orgId>/categories/<categoryId>/unsubmit
   */
   const unsubmitModule = async( org_id, cat_id) => {
    try {
      const result = await newApi.put(`/organizations/${org_id}/categories/${cat_id}/unsubmit`,{}, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      return result;
    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not unsubmit module'});
    }
  };

  const validateModule = async(org_id, cat_id) => {
    try {
      const result = await newApi.get(`/organizations/${org_id}/categories/${cat_id}/validate`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      return result;
    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not get data'});
    }
  };

  const getPriorityCategory = async org_id => {
    try {
      const result = await newApi.get(`/organizations/${org_id}/categories/tag/PROFILE`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;

    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not get data'});
    }
  };

  const putPriorityCategory = async org_id => {
    try {
      const result = await newApi.put(`/organizations/${org_id}/categories/tag/PROFILE`,{}, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;

    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not put data'});
    }
  };

  const getCdsCategory = async org_id => {
    try {
      const result = await newApi.get(`/organizations/${org_id}/categories/tag/CDS`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;

    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not get data'});
    }
  };


  const putCdsCategory = async org_id => {
    try {
      const result = await newApi.put(`/organizations/${org_id}/categories/tag/CDS`, {}, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;

    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not put data'});
    }
  };


  /* QUESTION TAG */
  //"/organizations/:id/categories/tag/:tag"
  const getQuestionTag= async (org_id, tag) => {
    try {
      const result = await newApi.get(`/organizations/${org_id}/categories/tag/${tag}`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;

    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not get data'});
    }
  };

  const putQuestionTag = async (org_id, tag) => {
    try {
      const result = await newApi.put(`/organizations/${org_id}/categories/tag/${tag}`, {}, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;

    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not put data'});
    }
  };

  const getAPCP= async org_id => {
    try {
      const result = await newApi.get(`/organizations/${org_id}/apCreditPolicies`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;

    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not get data'});
    }
  };


  const getReminderDescription = async() => {
    try {
      const result = await newApi.get('references', {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      if(result.status!==200||result.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return result;
    } catch (error) {
      dispatch({type:'ERROR', payload: 'could not get data'});
    }
  };
  const getMajors = React.useCallback(async org_id => {
    try {
      const res = await newApi.get(`/organizations/${org_id}/degreeOfferings?selected=true`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });

      if(res.status!==200||res.data.statusCode!==200) {
        return window.location.replace('apierror');
      }
      return res.data;
    }catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  }, []);

  const downloadFullPDF = async (orgId) => {
    try {
      const result = await newApi.get(`/organizations/${orgId}/download`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        },
        responseType: 'blob'
      });
      return result;
    } catch (error) {
      console.error('error while downloading full PDF');
    }
    return {};
  };

  const downloadPDF = async (orgId, categoryId) => {
    try {
      const result = await newApi.get(`/organizations/${orgId}/categories/${categoryId}/download`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        },
        responseType: 'blob'
      });
      return result;
    } catch (error) {
      console.error('error while downloading PDF');
    }
    return {};
  };

  //post events 
  const postEvents = async (data) => {
    try {
      const result = await newApi.post(`events`, data, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      return result;
    } catch (error) {
        //event is side effect, it should NOT block the process, silence the error.
        console.error(`postEvents failed`, error);
    }
  };

  const getLastUpdatedUser = async org_id => {
    try {
      const result = await newApi.get(`/org-answers/${org_id}/findlastupdateduser`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      return result;
    } catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  };

  const findorganswersbyorgidlasthed = async org_id => {
    try {
      const result = await newApi.get(`/org-answers/${org_id}/findorganswersbyorgidlasthed`, {
        headers: {
          'x-cb-Catapult-Authorization-Token': `${cb.core.iam.getAuthorizationToken()}`,
          'x-cb-Catapult-Authentication-Token': `${cb.core.iam.getAuthenticationToken()}`
        }
      });
      return result;
    } catch (error) {
      dispatch({type:'ERROR', payload: error});
    }
  };


  return(
    <Context.Provider value={{state, dispatch, updateLegalNotice, getReminderDescription,
      getPriorityCategory, getCategory, validateModule, publishCategory, getModules, getCdsCategory,
      getOrganizations, postModule, submitModule, unsubmitModule, getModuleById, getMajorsByKeyword, getMajors, getAPCP,
      postAPCPModule, putPriorityCategory, putCdsCategory, downloadPDF, downloadFullPDF, postEvents, getLastUpdatedUser,
      getQuestionTag, putQuestionTag, findorganswersbyorgidlasthed}}>
      {children}
    </Context.Provider>
  );
};
export default StoreProvider;

StoreProvider.propTypes = {
  children: PropTypes.element
};